import { useState } from "react";
import axios from "../../axios/AxiosInstance";
import { formatJsDateWithHour } from "../../utils/formatageDate";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AddCommentModal } from "../../components/reusableComponents/AddCommentModal";

const CandidateComment = ({ candidate, candidates, setCandidates }) => {
  const [commentaire, setCommentaire] = useState("");
  const [comments, setComments] = useState(candidate.comments);
  const [notation, setNotation] = useState(0);
  const [selection, setSelection] = useState("commentaires");
  const [isAddCommentModalOpen, setIsAddCommentModalOpen] = useState(false);

  const navigate = useNavigate();

  const updateCandidate = () => {
    let newComment = {
      comment: commentaire,
      createdAt: Date.now(),
      commentator: localStorage.getItem("name"),
    };
    axios
      .post(`tempworker-candidate/${candidate._id}/update-comment`, {
        comments: [newComment, ...comments],
      })
      .then((res) => {
        toast.success("Commentaire ajouté ! ");
        setComments([newComment, ...comments]);
        const candidateIdx = candidates.findIndex(
          (cdte) => cdte._id === candidate._id,
        );
        const newCandidates = [...candidates];
        newCandidates[candidateIdx] = {
          ...candidate,
          comments: [newComment, ...comments],
        };
        setCandidates(newCandidates);
      })
      .catch((e) => {
        if (e.response.data.statusCode === 403) {
          localStorage.clear();
          navigate("/login");
        }
      });
  };

  return (
    <div className="space-y-4">
      {isAddCommentModalOpen && (
        <AddCommentModal
          isOpen={isAddCommentModalOpen}
          onClose={() => setIsAddCommentModalOpen(false)}
          candidates={candidates}
          setCandidates={setCandidates}
          candidate={candidate}
          setComments={setComments}
        />
      )}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900">Commentaires</h3>
        <button
          className="px-3 py-1.5 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 flex items-center"
          onClick={() => setIsAddCommentModalOpen(true)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
              clipRule="evenodd"
            />
          </svg>
          Ajouter un commentaire
        </button>
      </div>

      <div className="space-y-4">
        {comments.map((comment) => {
          return (
            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <p className="font-medium text-gray-800">
                    {comment.commentator}
                  </p>
                  <p className="text-xs text-gray-500">
                    {formatJsDateWithHour(comment.createdAt)}
                  </p>
                </div>
                <span className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded text-xs">
                  {comment.type}
                </span>
              </div>
              <p className="text-gray-700">{comment.comment}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CandidateComment;
